export default __webpack_public_path__ + "static/media/Logo.95361680.png";